var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading && !_vm.aliases.length
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.aliases.length
        ? _c("feature-setup", {
            attrs: {
              feature: "aliases"
            },
            on: {
              create: function create($event) {
                _vm.adding = true
              }
            }
          })
        : _c(
            "gg-card",
            [
              _c("gg-card-header", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center flex-wrap"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "mr-auto"
                      },
                      [_vm._v("Aliases")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            _vm.adding = true
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Create Alias ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "gg-card-text",
                [
                  _c(
                    "p",
                    {
                      staticClass: "body-2 mb-4"
                    },
                    [
                      _vm._v(
                        " Mail sent to an alias is delivered to " +
                          _vm._s(_vm.mailbox.email) +
                          ". "
                      )
                    ]
                  ),
                  _c(
                    "table-wrapper",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.aliases,
                          loading: _vm.loading,
                          "loading-text": "Loading aliases…",
                          "item-key": "dest",
                          "sort-by": "dest"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.actions",
                            fn: function fn(_ref) {
                              var item = _ref.item
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-right"
                                  },
                                  [
                                    _c(
                                      "gg-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          secondary: "",
                                          "aria-label": "Delete alias ".concat(
                                            item.dest
                                          )
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.confirmDelete(item)
                                          }
                                        }
                                      },
                                      [_vm._v(" Delete ")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _c("delete-alias-modal", {
        attrs: {
          "is-active": _vm.confirming,
          alias: _vm.selected,
          mailbox: _vm.mailbox
        },
        on: {
          close: function close($event) {
            _vm.confirming = false
          },
          deleted: _vm.onChanged
        }
      }),
      _c("add-alias-modal", {
        attrs: {
          "is-active": _vm.adding,
          mailbox: _vm.mailbox
        },
        on: {
          close: function close($event) {
            _vm.adding = false
          },
          created: _vm.onChanged
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }